import { DataModelBuilder, isSameList, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { BusinessCategory } from '../../models/serializable/business-category.js';
import { fromEnumAsString, toEnumFromString } from '../../serialization/enum-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class BusinessClassificationComponent extends Component {
  static readonly TYPE_ID: string = 'd519d56ff6aa4c32bca9dc341a7aae68';

  constructor(
    public readonly classification: BusinessCategory[],
  ) {
    super();
  }

  get $typeId(): string {
    return BusinessClassificationComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): BusinessClassificationComponent {
    return new BusinessClassificationComponent(
        MapUtils.getList<BusinessCategory>(
            map,
            'classification',
            (value) => toEnumFromString(
                value as string,
                BusinessCategory,
            ) ?? BusinessCategory.Other),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'classification': this.classification.map((e) => fromEnumAsString(e)),
    };
  }

  clone(): this {
    return new BusinessClassificationComponent(
        this.classification,
    ) as this;
  }

  isSame(other: BusinessClassificationComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameList(other.classification, this.classification);
  }
}

export class BusinessClassificationComponentBuilder extends DataModelBuilder<BusinessClassificationComponent> {
  build(context: SerializationContext, map: SerializedData): BusinessClassificationComponent {
    return BusinessClassificationComponent.fromMap(context, map);
  }

  migrateToCurrentSchemaVersion(context: SerializationContext, map: SerializedData): SerializedData | null {
    this.migrateEnumList(map, 'classification', BusinessCategory);

    return map;
  }
}
